
import { Alert, Button, Row, Spin, Tabs, Col, List, Modal, Select, Input, Form } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeTemplateId, loadTemplates, changeTab, selectCategory, showNewLawReportDialog, hideNewLawReportDialog, createLawReport, changeOriginalFilename } from './lawReportActions';
import styles from './lawReport.css'
import { Redirect, withRouter } from 'react-router-dom';
import MaterialIcon from 'material-icons-react';
import { formItemLayout, getRequiredRule } from '../utils/antUtils';

const Option = Select.Option;
const { TabPane } = Tabs;
const FormItem = Form.Item;

const tabs = ['Teman', 'Källa-teman', 'Publikationsbeteckning', 'Målnr/Dnr', 'Beslutsdatum', 'Organisation', 'Lagrum', 'Ej pub.'];

const categoryWidths = {
  1: [5, 5, 5, 5],
  2: [5, 5, 5, 5],
  3: [5, 5, 5, 5],
  4: [5, 5, 5, 5],
  5: [5, 5, 5, 5],
  6: [4, 4, 4, 4],
  7: [12, 4],
  8: [4, 4, 4, 4],
}

class LawReportComponent extends Component {

  state = {
    newOriginalFileName: '',
    newType: ''
  }

  componentDidMount() {
    if (this.props.entries[0].length === 0) {
      this.onChangeTab(1);
    }

    this.props.dispatch(loadTemplates())
  }

  create() {

  }

  onChangeTab = (searchType) => {
    this.props.dispatch(changeTab(searchType))
  }

  selectSource = (uri) => {
    this.props.history.push(uri);
  }

  selectCategory = (index, id) => {

    let options = [...this.props.options];
    if (index >= options.length) {
      options.push(id)
    }
    else {
      options[index] = id;
      options = options.slice(0, index + 1);
    }

    this.props.dispatch(selectCategory(this.props.searchType, options))
  }

  onChangeOriginaFilename(value) {

  }

  saveNewLawReport() {
    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      this.props.dispatch(createLawReport(this.props.originalFileName, this.props.templateId));
    });
  }

  showUpload() {
    window.location = '/rattsfall-uppladdning';
  };

  render() {

    if (this.props.createdSbtId > 0) {
      return <Redirect to={`/rattsfall/${this.props.createdSbtId}`} />;
    }

    const { getFieldDecorator } = this.props.form;

    let widths = categoryWidths[this.props.searchType];

    return (
      <Spin spinning={this.props.loading}>

        <Modal
          title="Skapa ny"
          visible={this.props.showNewLawreport}
          onOk={() => this.saveNewLawReport()}
          onCancel={() => this.props.dispatch(hideNewLawReportDialog())}
          okText="OK"
          maskClosable={false}
          cancelText="Avbryt"
          width={800}
        >
          {this.props.createdSbtId === 0 ? <Alert
            message="Produktionsbeteckning finns redan"
            type="error"
            style={{ marginBottom: 20 }}
          /> : ''}
          <Form onSubmit={this.handleSubmit} >
            <FormItem {...formItemLayout} label="Produktionsbeteckning" >
              {getFieldDecorator('originalFileName', { rules: [getRequiredRule('Ange en produktionsbeteckning')], })(
                <Input autoFocus onBlur={(e) => this.props.dispatch(changeOriginalFilename(e.target.value))} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Skapa från mall" >
              {getFieldDecorator('templateId')(
                <Select style={{ width: '100%' }} allowClear showSearch optionFilterProp="children" onChange={(e) => this.props.dispatch(changeTemplateId(e))} >
                  {this.props.templates.map((s) => (<Option key={s.id} value={s.id}>{s.name}</Option>))}
                </Select>
              )}
            </FormItem>
          </Form>
        </Modal>

        <div>
          <Button icon='plus' type='primary' style={{ float: 'right', zIndex: 10000 }} size='large' onClick={() => this.props.dispatch(showNewLawReportDialog())} >Skapa ny</Button>
          <Button icon='upload' type='primary' style={{ float: 'right', zIndex: 10000, marginRight: 10 }} size='large' onClick={() => this.showUpload()} >Ladda upp PDF filer</Button>

          <Row>
            <Tabs activeKey={'' + this.props.searchType} onChange={this.onChangeTab} >
              {tabs.map((tabName, index) => (<TabPane tab={tabName} key={index + 1}></TabPane>))}
            </Tabs>
          </Row>
          <Row>
            {this.props.entries.map((entry, entryIndex) => {

              return (entry.length > 0 && <Col span={widths[entryIndex]} style={styles.categoryList} key={entryIndex}>
                <List
                  size="small"
                  bordered
                  dataSource={entry}
                  renderItem={item => {
                    let isSelected = item.id == this.props.options[entryIndex];
                    let style = isSelected ? styles.categoryEntrySelected : styles.categoryEntry;
                    return (<List.Item onClick={() => this.selectCategory(entryIndex, item.id)} style={style}>{item.name}</List.Item>)
                  }}
                />
              </Col>)
            })}

            {this.props.summary.length > 0 && <Col span={4} style={styles.categoryList}>
              <List
                size="small"
                bordered
                dataSource={this.props.summary}
                renderItem={item => (<List.Item onClick={() => this.selectSource(item.id)} style={styles.categoryEntry}>

                  <MaterialIcon style={{ marginTop: 3 }} icon={item.special ? '' : 'gavel'} size={16} />
                  <span style={{ paddingLeft: 20 }}>
                    {item.name}
                  </span>
                </List.Item>)}
              />
            </Col>}

          </Row>
        </div>
      </Spin>)
  }
}


const mapStateToProps = (state) => ({
  loading: state.lawreport.loading,
  entries: state.lawreport.entries,
  searchType: state.lawreport.searchType,
  options: state.lawreport.options,
  summary: state.lawreport.summary,
  showNewLawreport: state.lawreport.showNewLawreport,
  originalFileName: state.lawreport.originalFileName,
  createdSbtId: state.lawreport.createdSbtId,
  templates: state.lawreport.templates,
  templateId: state.lawreport.templateId
});

export default connect(mapStateToProps)(withRouter(Form.create({
  mapPropsToFields(props) {

    return {
      originalFileName: Form.createFormField({ value: props.originalFileName }),
      templateId: Form.createFormField({ value: props.templateId }),
    }
  }
})(LawReportComponent)));



// WEBPACK FOOTER //
// ./src/lawreport/lawReportComponent.js